import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTruck } from 'react-icons/fa';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import { useToast } from '../../components/ToastProvider';



const Orders = () => {
    const { lastOrderTime } = useCustomerAuth(); // Consume context
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const BASE_URL = process.env.REACT_APP_API_BASE || 'https://handmade-haven.in';
                // Add timestamp to query to prevent caching
                const res = await fetch(`${BASE_URL}/api/customer/orders.php?_t=${Date.now()}`, {
                    credentials: 'include',
                    cache: 'no-store'
                });
                const data = await res.json();
                if (data.ok) {
                    setOrders(data.orders);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [lastOrderTime]); // Refetch when this changes

    if (loading) return <div>Loading orders...</div>;

    return (
        <div>
            <h2 className="account-section-title">My Orders</h2>
            {orders.length === 0 ? (
                <p>No orders found.</p>
            ) : (
                <div className="orders-list">
                    {orders.map(order => (
                        <div key={order.id} className="order-card">
                            <Link to={`/account/orders/${order.id}`} className="order-link">
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                    <div>
                                        <strong style={{ color: '#d14c87', fontSize: '1.05rem' }}>Order #{order.id}</strong>
                                        <br />
                                        <small style={{ color: '#888' }}>{new Date(order.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</small>
                                        {(order.status === 'processing' || order.status === 'shipped' || order.status === 'pending') && (
                                            <div className="delivery-estimate" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <FaTruck size={14} /> Estimated delivery: Ships within 1–2 days, delivered in 3–7 days
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <span style={{
                                            padding: '4px 10px',
                                            borderRadius: '20px',
                                            fontSize: '0.85rem',
                                            background: order.status === 'delivered' ? '#e6fffa' :
                                                order.status === 'shipped' ? '#fffde7' :
                                                    order.status === 'processing' ? '#fff5f7' :
                                                        order.status === 'cancelled' ? '#ffebee' : '#fff5f5',
                                            color: order.status === 'delivered' ? '#047857' :
                                                order.status === 'shipped' ? '#f57f17' :
                                                    order.status === 'processing' ? '#b83280' :
                                                        order.status === 'cancelled' ? '#c62828' : '#c53030',
                                            border: order.status === 'shipped' ? '1px solid #fdd835' : '1px solid transparent', // Add border for gold readability
                                            fontWeight: 600,
                                            textTransform: 'capitalize'
                                        }}>
                                            {order.status}
                                        </span>
                                        <div style={{ fontWeight: 'bold', marginTop: '5px', color: '#333' }}>₹{order.total}</div>
                                    </div>
                                </div>
                                <div>
                                    {order.items && order.items.map((item, idx) => (
                                        <div key={idx} style={{ fontSize: '0.9rem', color: '#555', marginBottom: '4px', display: 'flex', justifyContent: 'space-between' }}>
                                            <span>{item.qty}x {item.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Orders;
